export function useCirculairesDisplayAds() {
  const userStore = useUserStore()
  const baseStore = useBaseStore()

  const showCirculairesAds = computed(
    () => baseStore.showAds && baseStore?.platform === 'web' && (!userStore?.user || userStore.user.extra != 1),
  )

  function shouldShowGridInlineAd(index: number): boolean {
    return [2, 6].includes(index + 1)
  }

  function shouldShowListInlineAd(index: number, totalItems: number): boolean {
    const middlePosition = Math.min(12, Math.ceil(totalItems / 2))

    return index + 1 === middlePosition
  }

  const listInlineAdSizes = [[970, 250], [728, 90], [320, 50], [300, 250]]
  const listInlineAdSizeMapping = [[[0, 0], [[320, 50], [300, 250]]], [[768, 0], [[728, 90]]], [[1024, 0], [[970, 250], [728, 90]]]]

  return {
    showCirculairesAds,
    shouldShowGridInlineAd,
    shouldShowListInlineAd,
    listInlineAdSizes,
    listInlineAdSizeMapping,
  }
}
